// Calendly configuration — swap CALENDLY_URL below for your firm's scheduling link.
export const CALENDLY_URL = "https://calendly.com/marina-corporaco/30min";

/**
 * Open Calendly in a popup widget (loaded from index.html <script>).
 * Falls back to opening in a new tab if the widget hasn't finished loading.
 */
export function openCalendly(options = {}) {
  const url = options.url || CALENDLY_URL;
  if (typeof window !== "undefined" && window.Calendly && window.Calendly.initPopupWidget) {
    try {
      window.Calendly.initPopupWidget({ url });
      return;
    } catch {
      /* fall through to tab open */
    }
  }
  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}

/**
 * Dispatch a global event to open the Corpora Counsel chat widget from anywhere.
 */
export function openChat() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("corpora:open-chat"));
  }
}
